import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { ChangeaddressesPage } from '../changeaddresses/changeaddresses';
import { EditAddressPage } from '../edit-address/edit-address';
 

/**
 * Generated class for the AddressesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addresses',
  templateUrl: 'addresses.html',
})
export class AddressesPage {
  tab1Root=ChangeaddressesPage
  tab2Root = EditAddressPage
  address:any={}
  officetype:any;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad AddressesPage',this.navParams);
    this.address=this.navParams.get("queryParams");
    this.officetype=this.navParams.get("currentAdd")?'Current':'Office';
  }

}



// WEBPACK FOOTER //
// ./src/pages/addresses/addresses.ts